import React from "react";
import { Table, message, Card, Avatar, Typography } from "antd";
import { baseImageUrl } from "Common/Components/baseImageUrl";
import { UserOutlined } from "@ant-design/icons";
import useServerPagination from "Common/hooks/useServerPagination";

const { Text } = Typography;

// Fetch a page of mentors from the paginated backend list API.
const fetchMentors = async ({ pageNumber, pageSize, orderByLatest }) => {
  const token = localStorage.getItem("token");
  const qs = new URLSearchParams({ pageNumber, pageSize, orderByLatest }).toString();
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/Mentor/GetListAll?${qs}`,
    {
      method: "GET",
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch mentors");
  }

  return response.json();
};

const MentorsList = () => {
  const { items, loading, paginationProps } = useServerPagination(fetchMentors, {}, {
    onError: () => message.error("Failed to load mentors data"),
  });

  const columns = [
    {
      title: "Mentor",
      dataIndex: "profileImage",
      key: "profileImage",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <Avatar
            src={record.profileImage ? `${baseImageUrl}${record.profileImage}` : null}
            icon={!record.profileImage && <UserOutlined />}
            size="large"
            style={{
              backgroundColor: record.profileImage ? "transparent" : "#B17F14",
            }}
          />
          <Text strong>
            {record.firstName} {record.lastName}
          </Text>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Phone",
      dataIndex: "phoneNo",
      key: "phoneNo",
      render: (text) => (text ? text : "N/A"),
    },
    {
      title: "Date Joined",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (date) => new Date(date).toLocaleDateString(),
    },
  ];

  return (
    <Card className="card-professional" title="Mentors List" variant="borderless">
      <Table
        columns={columns}
        dataSource={items}
        rowKey="mentorId"
        loading={loading}
        pagination={paginationProps}
        scroll={{ x: true }}
      />
    </Card>
  );
};

export default MentorsList;
